import React, { useEffect, useState } from "react";
import { buildApiUrl } from "../config";  // ✅ Import config

const StudentTTRS = () => {
  const [studentTTRS, setStudentTTRS] = useState(null);

  useEffect(() => {
    const schoolId = localStorage.getItem("schoolId");

    fetch("/data/ttrs.json")
      .then((res) => res.json())
      .then((data) => {
        const match = data.find((s) => s.schoolId === schoolId);
        setStudentTTRS(match);
      });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      {studentTTRS ? (
        <div className="bg-white p-6 rounded-xl shadow-md max-w-md mx-auto mt-8">
          <h2 className="text-xl font-bold text-indigo-700 mb-4">Welcome {studentTTRS.firstName}!</h2>
          <p className="mb-2">Use the following login details for TTRS:</p>
          <div className="bg-gray-100 p-4 rounded mb-4">
            <p><strong>Username:</strong> {studentTTRS.ttUsername}</p>
            <p><strong>Password:</strong> {studentTTRS.ttPassword}</p>
          </div>
          <a
            href="https://play.ttrockstars.com/auth/school/student/9734/password"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700"
          >
            Launch TTRS
          </a>
        </div>
      ) : (
        <p className="text-center text-gray-500 mt-12">Loading TTRS info...</p>
      )}
    </div>
  );
};

export default StudentTTRS;
